import { useMutation } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { IServerErrorResponse } from '../../../types';
import { trackMixPanel } from '../../../services/mixpanel.service';
import { flattenServerErrorResponse } from '../../../helpers/errors.helper';

interface IProps {
    customerId: string;
    transactionId: string;
    fdPayload: FormData;
}

export const usePostCheckConfirmation = () => useMutation(
  'usePostCheckConfirmation',
  async ({ customerId, transactionId, fdPayload }: IProps) => {
    await httpService.post(`${BASE_URL}/api/v1/user/${customerId}/transactions/${transactionId}/mail/check`, fdPayload);
  },
  {
    retry: 1,
    onError: (e:IServerErrorResponse) => {
      const { localizedMessage, code } = flattenServerErrorResponse(e);
      trackMixPanel('Error Occurred During Move Money Flow', {
        'Error Code': code, 'Error Message': localizedMessage, 'Screen Name': 'Review', Flow: 'Mail a Check',
      });
    },
  },
);
